import { useState } from 'react';
import axios from 'axios';
import AppURL from '../components/AppUrl';
// import { useNavigate } from 'react-router-dom';
// const navigate = useNavigate();

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${AppURL}/api/employees/login`, {
        email,
        password
      });

      if (response.data.message === "Connexion réussie") {
        localStorage.setItem('userData', JSON.stringify({
          name: response.data.user.name,
          email: response.data.user.email,
          role: response.data.user.role,
          id: response.data.user.id,
        }));

        window.location.href = '/employee';
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError('Échec de la connexion. Vérifiez vos identifiants.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-center px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 sm:p-10 max-w-md w-full space-y-6">
        <h2 className="text-3xl font-extrabold text-center text-blue-700">Bienvenue 👋</h2>
        <p className="text-center text-gray-500">Connectez-vous à votre espace employé</p>

        {error && (
          <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="block text-gray-600 mb-1">Adresse email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="exemple@domaine.com"
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-gray-600 mb-1">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="********"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-2 rounded-lg hover:bg-blue-700 transition-all duration-300"
          >
            Se connecter
          </button>
        </form>

        <div className="text-center text-sm text-gray-500 pt-4 border-t">
          Vous n'avez pas encore de compte ? Contactez l'administrateur.
        </div>
      </div>
    </div>
  );
};

export default Login;
